import { render } from "./feather.vue?vue&type=template&id=784a2038"
import script from "./feather.vue?vue&type=script&lang=js"
export * from "./feather.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__